// constants/chargeStatus.js

export const CHARGE_STATUS_TYPES_DIC = {
  RECEIVED: "received",
  CANCELLED: "cancelled",
  SENT: "sent",
}

export const CHARGE_STATUS_OPTIONS = {
  [CHARGE_STATUS_TYPES_DIC.RECEIVED]: {
    label: "RECIBIDO",
    className: "charge-status received-style"
  },
  [CHARGE_STATUS_TYPES_DIC.CANCELLED]: {
    label: "ANULADO",
    className: "charge-status cancelled-style"
  },
  [CHARGE_STATUS_TYPES_DIC.SENT]: {
    label: "ENVIADO",
    className: "charge-status sent-style"
  }
}

export const DOCUMENT_TYPE_DIC = {
  FACTURA: "F",
  CREDITO: "C",
  ABONO: "P",
  ENTREGA: "DR"
}

export const DOCUMENT_TYPE_OPTIONS = {
  [DOCUMENT_TYPE_DIC.FACTURA]: "FACTURA",
  [DOCUMENT_TYPE_DIC.CREDITO]: "NOTA DE CRÉDITO",
  [DOCUMENT_TYPE_DIC.ABONO]: "ABONO",
  [DOCUMENT_TYPE_DIC.ENTREGA]: "ENTREGA"
}

export const FILTER_KEYS = {
  USER: 'NOMBRE DE USUARIO',
  CLIENT: 'NOMBRE DE CLIENTE',
  DOCUMENT_TYPE: 'TIPO DE COBRO',
  STATUS: 'ESTADO DE COBRO',
}


export const TYPEDOCUMENTCHARGES = Object.values(DOCUMENT_TYPE_OPTIONS)  
// ["FACTURA", "NOTA DE CRÉDITO", "ABONO", "ENTREGA"]

export const TYPESTATUSCHARGES = Object.values(CHARGE_STATUS_OPTIONS).map(opt => opt.label)  
// ["RECIBIDO", "ANULADO", "ENVIADO"]

export const LABEL_TO_DOCUMENT_VALUE = Object.fromEntries(
  Object.entries(DOCUMENT_TYPE_OPTIONS).map(([value, label]) => [label, value])
)

export const LABEL_TO_STATUS_VALUE = Object.fromEntries(
  Object.entries(CHARGE_STATUS_OPTIONS).map(([value, obj]) => [obj.label, value])
)